import React, { useMemo } from 'react';
import { ThemeProvider } from '@emotion/react';
import { akEditorDefaultLayoutWidth } from '@atlaskit/editor-shared-styles';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { CHANNEL, fontSize } from '@atlaskit/theme/constants';
import { WidthConsumer } from '../WidthProvider';
export function mapBreakpointToLayoutMaxWidth(breakpoint) {
  switch (breakpoint) {
    case 'M':
      return 760;

    case 'L':
      return 850;

    default:
      return 680;
  }
}
export function BaseThemeWrapper({
  baseFontSize,
  children
}) {
  const {
    mode
  } = useGlobalTheme();
  const memoizedTheme = useMemo(() => ({
    baseFontSize: baseFontSize || fontSize(),
    layoutMaxWidth: akEditorDefaultLayoutWidth,
    // Below is used for editor dark mode.
    [CHANNEL]: {
      mode
    }
  }), [baseFontSize, mode]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: memoizedTheme
  }, children);
}
export function BaseTheme({
  children,
  baseFontSize
}) {
  return /*#__PURE__*/React.createElement(WidthConsumer, null, ({
    breakpoint
  }) => /*#__PURE__*/React.createElement(BaseThemeWrapper, {
    breakpoint: breakpoint,
    baseFontSize: baseFontSize
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children)));
}